import { priceFormatter } from './price-formatter';
import { COUNTRY_CODE } from '../../constants/app-constants';

const makeOdometerLabel = (price, country = COUNTRY_CODE.IN) => `${priceFormatter(price, true, country)} km`;

export const makeOdometerLabelAE = (price) => {
    return makeOdometerLabel(Math.round(price), COUNTRY_CODE.AE);
};
